import { HeadData } from '@/components/HeadData';
import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { SelectUserEnrollmentContainer } from './-container';
import { useSelectUserEnrollment } from './-hooks/useSelectUserEnrollment';

export const GET_USER_ENROLLMENTS = graphql(/* GraphQL */ `
  query UserEnrollments {
    selectableEmbaUserEnrollments {
      embaUserEnrollments {
        ...UserEnrollmentListItem
      }
      recommendedEmbaUserEnrollment {
        id
      }
    }
  }
`);

type SelectUserEnrollmentSearch = {
  disableAutoSelect: boolean;
};

export const Route = createFileRoute(
  '/_gloplaUserLayout/select-user-enrollment/',
)({
  component: component,
  validateSearch: (
    search: Record<string, unknown>,
  ): SelectUserEnrollmentSearch => {
    // validate and parse the search params into a typed state
    return {
      disableAutoSelect: (search.disableAutoSelect || false) as boolean,
    };
  },
});

function component() {
  const { disableAutoSelect } = Route.useSearch();

  const { error, data } = useSuspenseQuery(GET_USER_ENROLLMENTS);

  const { selectUserEnrollment, selectUserEnrollmentMutationError } =
    useSelectUserEnrollment();

  const [isRedirectChecked, setIsRedirectChecked] = useState(false);

  useEffect(() => {
    if (
      !disableAutoSelect &&
      data?.selectableEmbaUserEnrollments?.recommendedEmbaUserEnrollment
    ) {
      const id =
        data.selectableEmbaUserEnrollments.recommendedEmbaUserEnrollment.id;
      selectUserEnrollment(id);
    } else {
      setIsRedirectChecked(true);
    }
  }, [data, selectUserEnrollment, disableAutoSelect]);

  if (error) {
    throw error;
  }

  if (selectUserEnrollmentMutationError) {
    throw selectUserEnrollmentMutationError;
  }

  if (!isRedirectChecked) {
    // TODO: loading 画面を表示する
    return null;
  }

  return (
    <>
      <HeadData title="開講データ選択" />
      <SelectUserEnrollmentContainer
        selectableEmbaUserEnrollments={
          data.selectableEmbaUserEnrollments.embaUserEnrollments
        }
        selectUserEnrollment={selectUserEnrollment}
      />
    </>
  );
}
